import i18next from 'i18next'

export const getUserInitials = (firstName, lastName, email) => {
  if (firstName && lastName) {
    return `${firstName[0]}${lastName[0]}`
  } else if (email) {
    return email.substring(0, 2).toUpperCase()
  } else {
    return '--'
  }
}

export const getUserFullName = (firstName, lastName, email) =>
  firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName || email || i18next.t('Someone')

export const getUserNameOrEmail = (firstName, lastName, email) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`
  } else if (firstName || lastName) {
    return firstName || lastName
  } else {
    return email
  }
}

export const getJoinedUserFullName = (firstName, lastName, email) => {
  return getUserFullName(firstName, lastName, email)
    .split(' ')
    .join('_')
}
